<script>
import FeatureBlock from '@/components/FeatureBlock.vue'
export default {
  name: 'GamesSection',
  components: {
    FeatureBlock
  },
  data () {
    return {
      sectionSlideKey: 0
    }
  }
}
</script>
<template>
  <section
    class="better-foundation"
  >
    <div class="responsive-rows">
      <aside class="slideshow-column">
        <div class="">
          <video class="box" src="/video/demo.webm" controls />
        </div>
      </aside>
      <article class="">
        <header class="has-text-centered">
          <h2 class="article-title mb-4">
            Built for How Therapy Unfolds
          </h2>
        </header>
        <article class="feature-grid">
          <feature-block>
            <template #title>
              Structured Skill Progression
            </template>
            <template #content>
              Skills develop from early acquisition to real-world use
            </template>
          </feature-block>
          <feature-block>
            <template #title>
              Clinician-Guided Adaptation
            </template>
            <template #content>
              Therapy demand adjusts as patients progress
            </template>
          </feature-block>
          <feature-block>
            <template #title>
              Sustained Compliance
            </template>
            <template #content>
              Intentional variety keeps therapy practice sustainable over time
            </template>
          </feature-block>
        </article>
        <blockquote class="component-box my-4 font-semibold">
          <p>
            OVB is a game changer; they have built a better mousetrap. Compliance is way up because my patients are engaged. They weren't having fun before and now they are.
          </p>
          <p class="my-2">
            I love OVB in-office and know my patients are having fun with their VT homework.
          </p>
          <p class="" style="text-align: right;">&mdash;Dr. Ryan Capouch, OD FCOVD</p>
        </blockquote>
      </article>
    </div>
  </section>
</template>
<style lang="scss">
.better-foundation {
  .slide-title {
    margin-top: 1rem;
    margin-bottom: 1rem;
    line-height: $size-5;
    font-size: $size-5;
    font-weight: $font-bold;
    @include tablet {
      line-height: $size-3;
      font-size: $size-3;
    }
    @include desktop {
      line-height: $size-4;
      font-size: $size-4;
    }
    @include widescreen {
      line-height: $size-3;
      font-size: $size-3;
    }
  }
  .slide-content {
    font-size: $size-6;
    line-height: $size-6;
    font-weight: $font-semibold;
    @include tablet {
      line-height: $size-4;
      font-size: $size-4;
    }
    @include desktop {
      line-height: $size-6;
      font-size: $size-6;
    }
    @include widescreen {
      line-height: $size-4;
      font-size: $size-4;
    }
  }
  #slide-0 {
    .slide-overlay {
      background: linear-gradient(45deg, #2a4ae430, #fb949e6b)
    }
    .slide-title {
      font-weight: $font-black;
      color: $white;
    }
    ul {
      color: #fff;
      li {
        line-height: $size-6;
        margin-top: 0.5rem;
        @include tablet {
          line-height: 1.60rem;
          margin-top: 0.5rem;
        }
      }
    }
  }
  #slide-1 {
    .slide-overlay {
      background: linear-gradient(45deg, hsla(206, 31%, 50%, 10%), hsla(2, 78%, 83%, 70%) )
    }
    .content-container {
      max-width: 74%;
      @include tablet {
        max-width: 44%;
      }
      @include desktop {
        max-width: 80%;
      }
    }
    .slide-title {
      font-weight: $font-black;
      color: $white;
    }
    ul {
      color: #fff;
      li {
        line-height: 1.2;
        margin-top: 0.5rem;
        @include tablet {
          line-height: 1.60rem;
          margin-top: 0.65rem;
        }
      }
    }
  }
  #slide-2 {
    .slide-title {
      font-weight: $font-black;
      color: $white;
    }
    .slide-overlay {
      background: linear-gradient(45deg, #2a4ae430, #fb949e6b)
    }
    ul {
      color: #fff;
      li {
        line-height: 1.2;
        margin-top: 0.5rem;
        @include tablet {
          line-height: 1.60rem;
          margin-top: 0.65rem;
        }
      }
    }
  }
  .slide-tablet-1 {
    list-style: disc;
    margin-left: 1rem;
  }
  .slide-tablet-2 {
    max-width: 65%;
    list-style: disc;
    margin-left: 1rem;
  }
}

</style>
<style scoped lang="scss">
.feature {
  &-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 1rem;
    &-item {}
  }
  &-box {
    &-title {
      font-size: $size-5;
      font-family: $family-semibold;
      line-height: $size-5;
      margin-bottom: 0.5rem;
    }
    &-content {
      font-size: $size-6;
      line-height: 1.15;
    }
  }
}
.quote-box {
  padding: 0.5rem;
  border-radius: 0.5rem;
  background-color: $white;
  @include tablet {
    margin-bottom: 1rem;
  }
}
.responsive-rows {
  display: flex;
  flex-direction: column;
  //flex-wrap: wrap;
  @include tablet {
    display: grid;
    grid-template-columns: repeat( auto-fill, minmax(30rem, 1fr));
    grid-column-gap: 2rem;
    grid-row-gap: 1rem;
  }
  @include desktop {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 2rem;
    grid-row-gap: 1rem;
  }
  @include widescreen {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 2rem;
    grid-row-gap: 1rem;
  }
}
.play-now-button {
  background-color: $watermelon;
  color: $white;
}
.compliance-title {
  font-size: $size-3;
  line-height: $size-3;
  color: $feldgrau;
  font-weight: $font-semibold;;
}
.game-slides {
  box-shadow: rgba(0, 0, 0, 0.2) 0 10px 50px;
}
.detail-section {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.umbrella-container {
  display: block;
}
.umbrella-category-list {
  display: grid;
  grid-template-columns: repeat( auto-fit, minmax(5rem, 1fr));
  grid-column-gap: 2rem;
  grid-row-gap: 1rem;
  .umbrella-category-item {
    width: 6rem;
    display: flex;
    justify-content: center;
    figure {
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 5rem;
      }
    }
    figcaption {
      font-size: 90%;
      text-align: center;
      color: $feldgrau;
      line-height: 1rem;
      padding-top: 0.25rem;
    }
  }
}
ul.points-of-interest {
  columns: 3 22rem;
}
.points-of-interest {
  .poi {
    padding: 0.5rem;
  }
}
</style>
